// tickets status


import { Trans } from "@lingui/macro";
import React from "react";

export enum TICKETSTATUS  {
    OPEN ='OPEN',
    IN_PROGRESS ='IN_PROGRESS',
    COMPLETED='COMPLETED',
    CANCELLED='CANCELLED',
    ON_HOLD='ON_HOLD'
}

export enum TICKETSTATUSCOLOR  {
    OPEN ='red',
    IN_PROGRESS ='yellow',
    COMPLETED='green',
    CANCELLED='gray',
    ON_HOLD='indigo'
}


// Color chooser function
export const getColorTickets = (ticketsStatus ?: string): string => {
    switch (ticketsStatus ) {
        case TICKETSTATUS.OPEN:
            return TICKETSTATUSCOLOR.OPEN
        case TICKETSTATUS.IN_PROGRESS:
            return TICKETSTATUSCOLOR.IN_PROGRESS
        case TICKETSTATUS.CANCELLED:
            return TICKETSTATUSCOLOR.CANCELLED
        case TICKETSTATUS.COMPLETED:
            return TICKETSTATUSCOLOR.COMPLETED
        case TICKETSTATUS.ON_HOLD:
            return TICKETSTATUSCOLOR.ON_HOLD
        default:
            return TICKETSTATUS.OPEN
    }
}

export const getTransStatus = (status:string) : any=>{
    switch (status){
        case 'OPEN':
            return <Trans>Open</Trans>;
        case 'IN_PROGRESS': return (<Trans>In progress</Trans>)
        case 'COMPLETED': return <Trans>Completed</Trans>
        case 'CANCELLED': return <Trans>Cancelled</Trans>
        case 'ON_HOLD': return <Trans>On hold</Trans>
    }
}
